import React, { ReactElement, useEffect, useState } from 'react';
import SwiperCore, { Autoplay, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'gatsby';
import classNames from 'classnames';

import RightArrow from 'icons/arrow-right.svg';
import Arrow from 'icons/arrow-slider.svg';

import {
  EmbraceBackground,
  HowAiMatchingWorks,
  ImproveBackground,
  MakeTalentEfficient,
  MaximizeBackground,
  StreamlineBackground,
} from './components';

interface UseCase {
  title: string;
  link: string;
  description: string;
}

interface IProps {
  useCases: UseCase[];
}
const itemClass: string[] = ['magenta', 'grey', 'green', 'blue', 'grey', 'orange'];
const itemsBackground: (ReactElement | null)[] = [
  <HowAiMatchingWorks />,
  <MaximizeBackground />,
  <ImproveBackground />,
  <MakeTalentEfficient />,
  <StreamlineBackground />,
  <EmbraceBackground />,
];

SwiperCore.use([Navigation, Autoplay]);

export const HomePageUseCases = ({ useCases }: IProps) => {
  const [width, setWidth] = useState<any>();
  const [slidesPerView, setSlidesPerView] = useState<number | string>(4);
  const handleResize = (innerWidth: number) => {
    setWidth(innerWidth);
  };

  useEffect(() => {
    if (width >= 2237) {
      setSlidesPerView(6);
    } else if (width <= 2236 && width >= 1920) {
      setSlidesPerView(5.15);
    } else if (width <= 1919 && width >= 1441) {
      setSlidesPerView(4.5);
    } else if (width <= 1440 && width >= 1151) {
      setSlidesPerView(3.5);
    } else if (width <= 1150 && width >= 1024) {
      setSlidesPerView(2.5);
    } else if (width <= 1024 && width >= 768) {
      setSlidesPerView(2.5);
    } else if (width <= 767) {
      setSlidesPerView(1.5);
    }

    window.addEventListener('resize', () => handleResize(window.innerWidth));

    return () => {
      window.removeEventListener('resize', () => handleResize(window.innerWidth));
    };
  }, [width]);

  useEffect(() => {
    handleResize(window.innerWidth);
  }, []);

  const swiperParams = {
    spaceBetween: 0,
    slidesPerGroup: 1,
    slidesPerView,
    navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
    setWrapperSize: true,
    loopedSlides: 6,
    speed: 1500,
    initialSlide: 0,
  };

  return (
    <div className="block">
      <Swiper {...swiperParams}>
        {useCases.map((item, index) => (
          <SwiperSlide key={item.title}>
            <Link
              to={item.link}
              aria-label={`Link to use case ${item.title}`}
              className={classNames('block-item', itemClass[index])}
            >
              <h3 className="h2-title">{item.title}</h3>

              {itemsBackground[index]}
            </Link>
          </SwiperSlide>
        ))}
        <div className="swiper-button-next">
          <Arrow />
        </div>
        <div className="swiper-button-prev">
          <Arrow />
        </div>
      </Swiper>
    </div>
  );
};
